import { normalize, schema } from "normalizr";
import NotificationService from "../services/notification.service";
import userModule from "./user.module";

// import { normalize, schema, denormalize } from "normalizr";
import vuexHelpers from "../helpers/vuex.helpers";
const notificationEntity = new schema.Entity("notifications");
const getInitialState = function () {
    return {
        entities: {},
        ids: [],
        currentId: null,
        totalItems: 0,

        filenameCheck: null,
        selectedUsers: [],
    };
};
const initialState = getInitialState();

const getters = {
    find: (state) => (id) => {
        return state.entities.notifications[id];
    },
    current: (state, getters) => {
        return state.currentId !== null ? getters.find(state.currentId) : null;
    },
    list: (state, getters) => {
        return state.ids.map((id) => getters.find(id));
    },
    editMode: (state) => state.currentId !== null,
};

const mutations = {
    setNormalizedData(state, normalizedData) {
        state.entities = normalizedData.entities;
        state.ids = normalizedData.result;
    },
};

const actions = {
    async updateList({ commit }, list) {
        try {
            commit("setNormalizedData", normalize(list, [notificationEntity]));
        } catch (error) {
            await dispatch(
                "app/addAlert",
                {
                    text: error,
                },
                { root: true }
            );
        }
    },
    async search({ commit, dispatch }, q) {
        let task = await dispatch("app/addLoadingTask", "Caricamento notifiche", {
            root: true,
        });

        try {
            let res = await NotificationService.search(q);
            if (res.isError)
                throw "Errore nella ricerca delle notifiche";
            commit("setNormalizedData", normalize(res.data, [notificationEntity]));
        } catch (error) {
            await dispatch(
                "app/addAlert",
                {
                    text: error,
                },
                { root: true }
            );
        }
        commit("app/removeLoadingTaskById", task.id, { root: true });
    },
    async table({ commit, dispatch }, data) {
        let task = await dispatch("app/addLoadingTask", "Caricamento notifiche", {
            root: true,
        });

        try {
            let res = await NotificationService.table(data);
            if (res.isError)
                throw "Errore nel caricamento delle notifiche";
            commit('setTotalItems', res.data.totalItems)
            commit("setNormalizedData", normalize(res.data.items, [notificationEntity]));
        } catch (error) {
            await dispatch(
                "app/addAlert",
                {
                    text: error,
                },
                { root: true }
            );
        }
        commit("app/removeLoadingTaskById", task.id, { root: true });
    },
}

const notificationModule = {
    namespaced: true,
    state: initialState,
    modules: { users: userModule },
    getters: { ...vuexHelpers.getters(initialState), ...getters },
    actions: {
        ...actions
    },
    mutations: {
        ...vuexHelpers.mutations(getInitialState),
        // ...vuexHelpers.modelMutations(formCodiceModel, "codici", {
        //   setterEntityName: "codice",
        // }),
        ...mutations,
    },
};

export default notificationModule;
